import React, { useEffect, useState } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  Label,
  FormFeedback,
  Form,
  Button,
  Table
} from "reactstrap";
import Select from "react-select";
import { useFormik, useFormikContext, FieldArray } from "formik";
import * as Yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import classnames from 'classnames';
import CropModal from "../../Components/Common/CropModal";
import { useProfile } from "../../Components/Hooks/UserHooks";
import { useToast } from "../../Components/Common/ToastContext";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Dropzone from "react-dropzone";
import { 
  editPlanSubscription, 
  getProduct, 
  listPlanFeature, 
  listSpeacification, 
  listVariant, 
  viewPlanSubscription
} from "./_requests";

const EditPlanSubscription = (props: any) => {
  document.title = " Paal Dappa | Admin panel";
  const { userProfile } = useProfile();
  const { showToast } = useToast();
  const history = useNavigate();
  const { id } = useParams();
  const [selectedFeatures, setSelectedFeatures] = useState<number[]>([]);
  const [galleryImages, setGalleryImages] = useState<any[]>([]);
  const [deletedGalleryIds, setDeletedGalleryIds] = useState<number[]>([]);
  const [newGalleryFiles, setNewGalleryFiles] = useState<any[]>([]);

  console.log("id useParams state", id)
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      type: 1,
      plan_feature_id: "",
      no_of_times_used: 0,
      no_of_delivery_days: 0,
      referral_status: true,
      is_trial_plan: false,
      is_subscription: true,
      max_cancel_validity_days: 30,
      validity_type: "Days",
      max_purchase_count: 0,
      max_purchase_product: 0,
      list_order: 0,
      image: null, // Ensure image is included in initialValues
      description: "",
      details: [
        {
          is_loyalty_bonus: false,
          product_id: 0,
          variant_id: 0,
          variant_value: 0,
          validity: 0,
          free_validity_days: 0,
          validity_type: "Days",
          actual_amount: 0,
          per_day_amount: 0,
          offer_value: 0,
          offer_type: 0,
          offer_amount: 0,
          gross_amount: 0,
          productPriceId: 0,
          category_id: 0,
        },
      ],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter a Plan Name"),
      type: Yup.number()
        .typeError("Allowed numbers only, characters are not allowed")
        .required("Please Select Plan Type"),
      plan_feature_id: Yup.mixed()
        .test(
          "is-string-or-array",
          "Please Select Plan Features",
          (value) => typeof value === "string" || Array.isArray(value)
        )
        .required("Please Select Plan Features"),

      no_of_delivery_days: Yup.number()
        .typeError("Allowed numbers only, characters are not allowed")
        // .moreThan(0, "Please enter the maximum delivery days received through referral for this plan (e.g., 15 days).")
        .required("Please enter the maximum delivery days received through referral for this plan (e.g., 15 days)."),
      no_of_times_used: Yup.number()
        .typeError("Allowed numbers only, characters are not allowed")
        // .moreThan(0, "Please enter the no of times used this plan through referral (e.g., 1 or 2  time).")
        .required("Please enter the no of times used this plan through referral (e.g., 1 or 2  time)."),

      max_cancel_validity_days: Yup.number()
        .typeError("Allowed numbers only, characters are not allowed")
        .moreThan(0, "Please Enter Maximum Cancel days")
        .required("Please Maximum Cancel days"),
      validity_type: Yup.string().required("Please Select Validity Type"),
      list_order: Yup.number().typeError("Allowed numbers only").required("Please Enter List Order"),
      description: Yup.string().required("Please Enter Description"),
      image: Yup.mixed()
        .when("type", {
          is: (val: any) => Number(val) === 3,
          then: (schema) => schema.required("Please Select Image"),
          otherwise: (schema) => schema.notRequired(),
        })
        .test("dimensions", "Trial plan image dimensions are incorrect", function (value) {
          const { type } = this.parent;
          if (type !== 3 || !value || typeof value === "string") return true;

          return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(value as File);
            img.onload = () => {
              const isValid = img.width === 1512 && img.height === 448;
              if (!isValid) {
                // We can even customize the error message here
                resolve(this.createError({ message: `Trial plan image must be exactly 1512px (Width) * 448px (Height) (Selected image size ${img.width}px * ${img.height}px)` }));
              } else {
                resolve(true);
              }
            };
            img.onerror = () => resolve(this.createError({ message: "Invalid image file" }));
          });
        }),
      max_purchase_count: Yup.number()
        .typeError("Allowed numbers only")
        .when("type", {
          is: (val: any) => Number(val) === 3,
          then: (schema) => schema.required("Please Enter Max Order Count").min(1, "Must be at least 1"),
          otherwise: (schema) => schema.notRequired(),
        }),
      max_purchase_product: Yup.number()
        .typeError("Allowed numbers only")
        .when("type", {
          is: (val: any) => Number(val) === 3,
          then: (schema) =>
            schema
              .required("Please Enter Max Selectable Products")
              .min(1, "Must be at least 1")
              .test(
                "max-selectable",
                "Cannot exceed number of products added below",
                function (value) {
                  const { details } = this.parent;
                  const addedProductsCount = details?.filter((d: any) => d.product_id > 0).length || 0;
                  return (value || 0) <= addedProductsCount;
                }
              ),
          otherwise: (schema) => schema.notRequired(),
        }),
      details: Yup.array().of(
        Yup.object().shape({
          product_id: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .moreThan(0, "Please Enter Product ID")
            .required("Please Enter Product ID"),
          variant_id: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .moreThan(0, "Please Enter Variant ID")
            .required("Please Enter Variant ID"),
          variant_value: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .moreThan(0, "Please Enter Variant Value (2 KG, 5 L, 500ML)")
            .required("Please Enter Variant Value (2 KG, 5 L, 500ML)"),
          validity: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .moreThan(0, "Please Enter Validity")
            .required("Please Enter Validity"),
          validity_type: Yup.string().required("Please Enter Validity Type"),
          actual_amount: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            // .moreThan(0, "Please Enter Actual Amount")
            .required("Please Enter Actual Amount"),
          offer_type: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .when("offer_amount", {
              is: (val: any) => val !== undefined && val !== null && val !== "" && Number(val) !== 0,
              then: (schema) => schema.required("Please Select Offer Type"),
              otherwise: (schema) => schema
            }),
          offer_amount: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            // Remove .when("offer_type") to avoid cyclic dependency
            .notRequired(),
          gross_amount: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .required("Please Enter Gross Amount"),
          productPriceId: Yup.number()
            .typeError("Allowed numbers only, characters are not allowed")
            .moreThan(0, "Please select a valid variant")
            .required("Please Enter Product Price ID"),
        })
      ),
    }),
    onSubmit: async (values) => {
      console.log("Form Values:", values);

      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("type", String(values.type));
      formData.append("validity_type", String(values.validity_type));
      formData.append("max_cancel_validity_days", String(values.max_cancel_validity_days));
      formData.append("no_of_delivery_days", String(values.no_of_delivery_days));
      formData.append("no_of_times_used", String(values.no_of_times_used));
      formData.append("referral_status", String(values.referral_status));
      formData.append("is_subscription", String(values.is_subscription));
      formData.append("is_trial_plan", String(values.is_trial_plan));
      formData.append("max_purchase_count", String(values.max_purchase_count));
      formData.append("max_purchase_product", String(values.max_purchase_product));
      formData.append("list_order", String(values.list_order));
      formData.append(
        "plan_feature_id",
        Array.isArray(values.plan_feature_id)
          ? values.plan_feature_id.join(",")
          : values.plan_feature_id
      ); // Convert array to comma-separated string
      formData.append("description", values.description);
      if (values.image) {
        formData.append("image", values.image || "default.png"); // Ensure image is appended to formData
      }
      formData.append(
        "details",
        JSON.stringify(
          values.details.map((detail: any) => ({
            ...detail,
            is_loyalty_bonus: Boolean(detail.is_loyalty_bonus),
            product_id: Number(detail.product_id),
            category_id: Number(detail.category_id || 0),
            variant_value: Number(detail.variant_value),
            variant_id: Number(detail.variant_id),
            validity_type: String(detail.validity_type),
            validity: Number(detail.validity),
            free_validity_days: Number(detail.free_validity_days || 0),
            per_day_amount: Number(detail.per_day_amount),
            actual_amount: Number(detail.actual_amount),
            offer_value: Number(detail.offer_value),
            offer_type: Number(detail.offer_type),
            offer_amount: Number(detail.offer_amount),
            gross_amount: Number(detail.gross_amount),
            productPriceId: Number(detail.productPriceId),
          }))
        )
      );

      // Append new gallery files - Force flatten to prevent nesting
      const flatNewGalleryFiles = newGalleryFiles.flat(Infinity);
      flatNewGalleryFiles.forEach((file: any) => {
        if (file instanceof File || (file && file.preview)) {
          formData.append("gallery", file);
          formData.append("new_gallery_list_order", file.list_order || 0);
        }
      });

      // Append deleted gallery ids
      if (deletedGalleryIds.length > 0) {
        formData.append("deleted_gallery_ids", JSON.stringify(deletedGalleryIds));
      }

      // Append existing gallery metadata for list order updates
      formData.append("existing_gallery_data", JSON.stringify(galleryImages.map(img => ({
        id: img.id,
        list_order: img.list_order
      }))));

      if (userProfile && userProfile.id) {
        formData.append("updated_by", userProfile.id);
      }


      console.log("FormData:", formData);

      try {
        const res: any = await editPlanSubscription(id, formData);
        console.log("API Response: editPlanSubscription", res);
        console.log("res", res)
        console.log("res.data", res.data)
        console.log("res.status == true", res.status == true)
        if (res.status === true) {
          toast.success(res.message, res.status);
          validation.resetForm();
          history("/plan-subscription");
        } else {
          toast.error(res.message, res.status);
        }
      } catch (error) {
        console.error("Error in form submission:", error);
      }
    },
  });

  // Log when type changes and validate image dimensions for Trial
  useEffect(() => {
    console.log("Plan type changed:In editIn edit", validation.values.type,
      "Is trial plan:", validation.values.is_trial_plan);
    
    if (validation.values.type === 3 && validation.values.image) {
      const file = validation.values.image;
      if (file instanceof File) {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          if (img.width !== 1512 || img.height !== 448) {
            validation.setFieldError("image", `Trial plan image must be exactly 1512px (Width) * 448px (Height) (Selected image size ${img.width}px * ${img.height}px)`);
          } else {
            validation.setFieldError("image", "");
          }
        };
      }
    } else if (validation.values.type !== 3 && validation.errors.image && validation.errors.image.includes("Trial plan image must be exactly 1512px (Width) * 448px (Height)")) {
      validation.setFieldError("image", "");
    }
  }, [validation.values.type, validation.values.image]);

  // Log when details array changes
  useEffect(() => {
    console.log("Plan details updated: In editIn edit", validation.values.details);
  }, [validation.values.details]);
  // Add this function near your other utility functions
  const logFormikState = () => {
    console.group("Formik State In edit");
    console.log("Values:In edit", validation.values);
    console.log("Errors:In edit", validation.errors);
    console.log("Touched:In edit", validation.touched);
    console.log("IsSubmitting:In edit", validation.isSubmitting);
    console.log("IsValid:In edit", validation.isValid);
    console.log("Dirty:In edit", validation.dirty);
    console.groupEnd();
  };

  // Then use it in your useEffect
  useEffect(() => {
    logFormikState();
  }, [validation.values, validation.errors, validation.touched]);

  const fetchInitialValues = async (id: string) => {
    try {
      const response = await viewPlanSubscription(id); // Replace with your API call
      const data = response.data;
      console.log("response.data fetchInitialValues edit plan", response.data)
      const featureIds = data?.plan_feature_id ? data.plan_feature_id.split(",").map(Number) : [];

      validation.setValues({
        name: data.name || "",
        type: data.type || 1,
        max_cancel_validity_days: data.max_cancel_validity_days || 30,
        no_of_times_used: data?.referral?.no_of_times_used || 0,
        no_of_delivery_days: data?.referral?.no_of_delivery_days || 0,
        referral_status: data?.referral?.referral_status || false,
        is_subscription: data?.is_subscription ?? true,
        is_trial_plan: data?.is_trial_plan || false,
        validity_type: data.validity_type || "Days",
        max_purchase_count: data.max_purchase_count || 0,
        max_purchase_product: data.max_purchase_product || 0,
        list_order: data.list_order || 0,
        plan_feature_id: featureIds,
        image: data.image || null,
        description: data.description || "",
        details: (data.details || []).map((detail: any) => ({
          id: detail.id,
          product_id: detail.product_id,
          is_loyalty_bonus: detail.is_loyalty_bonus,
          variant_id: detail.variant_id,
          variant_value: detail.variant_value, // Set variant_value
          validity: detail.validity,
          validity_type: detail.validity_type || "Days",
          actual_amount: detail.actual_amount,
          free_validity_days: detail.free_validity_days,
          per_day_amount: detail.per_day_amount,
          offer_amount: detail?.offer_amount,
          offer_value: detail?.offer_value,
          offer_type: Number(detail?.offer_type), // Convert offer_type to a number
          gross_amount: detail.gross_amount,
          productPriceId: detail.productPriceId,
          category_id: detail.category_id,
        })),
      });

      setSelectedFeatures(featureIds); // Update the selected features state
      setPreviewImage(data.image); // Set the preview image
      setGalleryImages((data.gallery || []).map((g: any) => ({
        id: g.id,
        image: g.image,
        list_order: g.listOrder || 0
      }))); // Set the gallery images with list_order

    } catch (error) {
      console.error("Error fetching initial values:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchInitialValues(id);
    }
  }, [id]);

  const [productList, setProductList] = useState<any[]>([]);

  useEffect(() => {

    listVariant().then((res: any) => {
      setAvailableVariants(res.data || []);
    });
    listPlanFeature().then((res: any) => {
      setAvailableFeature(res.data || []);

      getProduct().then((res: any) => {
        setProductList(res.data || []);
      });
    });

    // Cleanup function (if needed)
    return () => { };
  }, []);

  const [customActiveTab, setcustomActiveTab] = useState<any>("1");
  const toggleCustom = (tab: any) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const [availableFeature, setAvailableFeature] = useState<any[]>([]);
  const [availableVariants, setAvailableVariants] = useState<any[]>([]);
  console.log("availableFeature", availableFeature)

  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [selectedFiles, setSelectedFiles] = useState<File | null>(null);

  // Cropper states
  const [cropModal, setCropModal] = useState<boolean>(false);
  const [imageToCrop, setImageToCrop] = useState<string | null>(null);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files[0]) {
      const file = files[0];
      const isTrial = validation.values.type === 3;

      if (isTrial) {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target?.result) {
            setImageToCrop(e.target.result as string);
            setCropModal(true);
          }
        };
        reader.readAsDataURL(file);
        event.target.value = "";
      } else {
        setSelectedFiles(file);
        validation.setFieldValue("image", file);
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target?.result) setPreviewImage(e.target.result as string);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleCropSave = (croppedFile: File) => {
    setSelectedFiles(croppedFile);
    validation.setFieldValue("image", croppedFile);
    setPreviewImage(URL.createObjectURL(croppedFile));
    validation.setFieldError("image", "");
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    setSelectedFiles(null);
    validation.setFieldValue("image", null); // Reset formik value
  };
  const handleAddRow = () => {
    validation.setFieldValue("details", [
      ...validation.values.details,
      { is_loyalty_bonus: false, product_id: 0, variant_id: 0, category_id: 0, validity: 0, free_validity_days: 0, validity_type: "Days", per_day_amount: 0, actual_amount: 0, offer_value: 0, gross_amount: 0, offer_amount: 0, productPriceId: 0 }
    ]);
  };

  const handleRemoveRow = (index: any) => {
    const updatedRows = [...validation.values.details];
    updatedRows.splice(index, 1);
    validation.setFieldValue("details", updatedRows);
  };

  const scrollToError = (errors: any) => {
    const errorFields = Object.keys(errors);
    if (errorFields.length > 0) {
      const errorElement = document.querySelector(`[name="${errorFields[0]}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  const scrollToArrayError = (errors: any) => {
    const errorFields = Object.keys(errors);
    if (errorFields.length > 0) {
      const errorElement = document.querySelector(`[name="${errorFields[0]}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        for (const field of errorFields) {
          if (Array.isArray(errors[field])) {
            const nestedErrorElement = document.querySelector(`[name="${field}[0]"]`);
            if (nestedErrorElement) {
              nestedErrorElement.scrollIntoView({ behavior: "smooth", block: "center" });
              break;
            }
          }
        }
      }
    }
  };
  const handleAcceptedFiles = (files: any) => {
    const formattedFiles = files.map((file: any, index: number) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
        isNew: true,
        id: Math.random(), // Temp ID for local tracking
        list_order: (galleryImages.length + newGalleryFiles.length + index + 1)
      })
    );
    setNewGalleryFiles(prev => [...prev.flat(Infinity), ...formattedFiles]);
  };

  const removeGallery = (galleryId: any, isNew: boolean) => {
    // Helper to re-sequence all items across both states
    const resequence = (remainingExisting: any[], remainingNew: any[]) => {
      const allItems = [
        ...remainingExisting.map(img => ({ ...img, isNew: false })),
        ...remainingNew.map(img => ({ ...img, isNew: true }))
      ];
      
      const sequenced = allItems
        .sort((a, b) => (a.list_order || 0) - (b.list_order || 0))
        .map((img, index) => ({ ...img, list_order: index + 1 }));
        
      setGalleryImages(sequenced.filter(img => !img.isNew).map(({ isNew, ...img }) => img));
      setNewGalleryFiles(sequenced.filter(img => img.isNew).map(({ isNew, ...img }) => img));
    };

    if (isNew) {
      const filteredNew = newGalleryFiles.filter((img) => img.id !== galleryId);
      resequence(galleryImages, filteredNew);
    } else {
      setDeletedGalleryIds([...deletedGalleryIds, galleryId]);
      const filteredExisting = galleryImages.filter((img) => img.id !== galleryId);
      resequence(filteredExisting, newGalleryFiles);
    }
  };

  const handleGalleryOrderChange = (id: any, order: any, isNew: boolean) => {
    let newOrder = parseInt(order) || 1;
    const totalItems = galleryImages.length + newGalleryFiles.length;

    // Cap the order at the total number of items
    if (newOrder > totalItems) newOrder = totalItems;
    if (newOrder < 1) newOrder = 1;
    
    // Combine both arrays to calculate shifts correctly
    const allItems = [
      ...galleryImages.map(img => ({ ...img, isNew: false })),
      ...newGalleryFiles.map(img => ({ ...img, isNew: true }))
    ];

    const targetItem = allItems.find(img => img.id === id && img.isNew === isNew);
    if (!targetItem) return;

    const oldOrder = targetItem.list_order || 0;

    // Helper to calculate new order for any item
    const getUpdatedOrder = (img: any) => {
      let currentOrder = img.list_order || 0;
      if (img.id === id && img.isNew === isNew) {
        return newOrder;
      }
      if (newOrder < oldOrder) {
        if (currentOrder >= newOrder && currentOrder < oldOrder) {
          return currentOrder + 1;
        }
      } else if (newOrder > oldOrder) {
        if (currentOrder > oldOrder && currentOrder <= newOrder) {
          return currentOrder - 1;
        }
      }
      return currentOrder;
    };

    // Update both states preserving their original array positions
    setGalleryImages(prev => prev.map(img => ({ ...img, list_order: getUpdatedOrder({ ...img, isNew: false }) })));
    setNewGalleryFiles(prev => prev.map(img => ({ ...img, list_order: getUpdatedOrder({ ...img, isNew: true }) })));
  };


  function formatBytes(bytes: any, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleProductChange = (index: number, productId: number) => {
    const product = productList.find((p) => p.id === productId);
    const usedVariantIds = validation.values.details
      .filter((d: any, i: number) => i !== index && Number(d.product_id) === productId)
      .map((d: any) => Number(d.productPriceId));

    const totalVariants = product?.variants || [];
    const availableVariantsCount = totalVariants.filter((v: any) => !usedVariantIds.includes(Number(v.id))).length;

    if (availableVariantsCount === 0) {
      toast.error("no have remaining variants");
      // Allow selection so the message can be shown below the dropdown
    }

    const updatedDetails = [...validation.values.details];
    updatedDetails[index] = {
      ...updatedDetails[index],
      product_id: productId,
      category_id: product?.categoryId || 0,
      variant_id: 0,
      variant_value: 0,
      productPriceId: 0,
      per_day_amount: 0,
      actual_amount: 0,
    };
    validation.setFieldValue("details", updatedDetails);
  };

  const handleVariantChange = (index: number, productPriceId: number) => {
    const detail = validation.values.details[index];
    const productId = detail.product_id;
    const product = productList.find((p) => p.id === productId);
    const variantPrice = product?.variants?.find((v: any) => v.id === productPriceId);

    if (variantPrice) {
      const updatedDetail = {
        ...detail,
        productPriceId: variantPrice.id,
        variant_id: variantPrice.variant_id,
        variant_value: variantPrice.variant_value,
        per_day_amount: variantPrice.actual_amount,
      };

      // Trigger amount recalculation for the new per_day_amount using the updated detail
      handleCombinationChange(index, "per_day_amount", variantPrice.actual_amount, updatedDetail);
    }
  };

  const handleCombinationChange = (index: number, field: string, value: any, baseDetail?: any) => {
    const updatedDetails = [...validation.values.details];
    const detail = {
      ...(baseDetail || updatedDetails[index]),
      [field]: value,
    };

    // Safely parse numeric values, removing any non-numeric characters like currency symbols
    const perDay = parseFloat(String(detail.per_day_amount || "0").replace(/[^0-9.]/g, ""));
    const validity = parseFloat(String(detail.validity || "0").replace(/[^0-9.]/g, ""));
    const freeDays = parseFloat(String(detail.free_validity_days || "0").replace(/[^0-9.]/g, ""));

    // Recalculate Actual Amount
    const actualAmount = (validity + freeDays) * perDay;
    detail.actual_amount = actualAmount.toFixed(2);

    if (field === "gross_amount") {
      // When gross_amount is changed directly, back-calculate the discount/offer details
      const grossAmount = parseFloat(String(value || "0").replace(/[^0-9.]/g, ""));
      const offerAmount = actualAmount - grossAmount;
      detail.offer_amount = Math.max(0, offerAmount).toFixed(2);

      const offerType = parseInt(detail.offer_type || "0");
      if (offerType === 1) {
        detail.offer_value = detail.offer_amount;
      } else if (offerType === 2 && actualAmount > 0) {
        detail.offer_value = ((offerAmount / actualAmount) * 100).toFixed(2);
      }
    } else {
      // Auto-calculate offer and gross amount based on offer settings
      const offerType = parseInt(detail.offer_type || "0");
      let offerValue = parseFloat(String(detail.offer_value || "0").replace(/[^0-9.]/g, ""));

      // Validations
      if (offerType === 1 && offerValue > actualAmount) {
        toast.error(`Offer Amount cannot exceed Total Actual Amount (${actualAmount.toFixed(2)})`);
        offerValue = actualAmount;
        detail.offer_value = actualAmount.toFixed(2);
      } else if (offerType === 2 && offerValue > 100) {
        toast.error("Offer Percentage cannot exceed 100%");
        offerValue = 100;
        detail.offer_value = "100.00";
      }

      let calculatedOfferAmount = 0;

      if (freeDays > 0) {
        // Free days take precedence over other offers
        calculatedOfferAmount = freeDays * perDay;
        detail.offer_type = 2; // Represent as percentage for consistency
        detail.offer_value = actualAmount > 0 ? ((calculatedOfferAmount / actualAmount) * 100).toFixed(2) : "0.00";
      } else if (offerType === 1) {
        // Fixed amount discount
        calculatedOfferAmount = offerValue;
      } else if (offerType === 2) {
        // Percentage discount
        calculatedOfferAmount = (actualAmount * offerValue) / 100;
      } else {
        // Reset offer value when type is set to 0
        detail.offer_value = 0;
        calculatedOfferAmount = 0;
      }

      detail.offer_amount = calculatedOfferAmount.toFixed(2);
      detail.gross_amount = Math.max(0, actualAmount - calculatedOfferAmount).toFixed(2);
    }

    updatedDetails[index] = detail;
    validation.setFieldValue("details", updatedDetails);
  };



  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <Container fluid>
        <BreadCrumb title="Edit Subscription Products" pageTitle="Paal Dappa" />
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            if (Object.keys(validation.errors).length > 0) {
              scrollToError(validation.errors);
              scrollToArrayError(validation.errors);
            }
            return false;
          }}
        >
          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="product-title-input">
                      Plan Name  <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="product-title-input"
                      placeholder="Enter Plan Name"
                      name="name"
                      value={validation.values.name || ""}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      invalid={
                        validation.errors.name && validation.touched.name
                          ? true
                          : false
                      }
                    />
                    {validation.errors.name && validation.touched.name ? (
                      <FormFeedback type="invalid">
                        {validation.errors.name}
                      </FormFeedback>
                    ) : null}
                  </div>
                  <div>
                    <Label>Plan Description  <span className="text-danger">*</span></Label>
                    <ReactQuill
                      theme="snow"
                      value={validation.values.description}
                      onChange={(value: any) => validation.setFieldValue("description", value)}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, 3, false] }],
                          [{ font: [] }],
                          [{ size: ["small", false, "large", "huge"] }],
                          [{ color: [] }, { background: [] }],
                          ["bold", "italic", "underline"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          [{ align: [] }],
                          ["link", "image"],
                          ["clean"],
                        ],
                      }}
                      formats={[
                        "header",
                        "font",
                        "size",
                        "color",
                        "background",
                        "bold",
                        "italic",
                        "underline",
                        "list",
                        "bullet",
                        "align",
                        "link",
                        "image",
                      ]}
                    />
                    {validation.errors.description && validation.touched.description ? (
                      <FormFeedback type="invalid">
                        {validation.errors.description}
                      </FormFeedback>
                    ) : null}
                  </div>
                </CardBody>
              </Card>
              <Card className="pb-4">
                <CardHeader>
                  <h5 className="card-title mb-0"> Image {validation.values.type === 3 && <span className="text-danger">*</span>}</h5>
                </CardHeader>
                <CardBody>
                  <div className="mb-4 text-center">
                    <div className="d-inline-block">
                      <div className="position-relative mb-3">
                        {/* Improved Preview Container */}
                        <div className="border rounded bg-light p-2 mx-auto" style={{ maxWidth: '400px', minWidth: '150px' }}>
                          {previewImage ? (
                            <div className="position-relative">
                              <img
                                src={previewImage}
                                id="product-img"
                                alt="Selected"
                                className="img-fluid rounded"
                                style={{ maxHeight: '200px', objectFit: 'contain' }}
                              />
                              <Button
                                type="button"
                                color="danger"
                                size="sm"
                                className="position-absolute top-0 end-0 rounded-circle"
                                style={{ transform: 'translate(50%, -50%)', padding: '0', width: '24px', height: '24px', minWidth: '24px' }}
                                onClick={handleRemoveImage}
                                title="Remove Image"
                              >
                                <i className="ri-close-line"></i>
                              </Button>
                            </div>
                          ) : (
                            <div className="py-4 text-muted">
                              <i className="ri-image-line display-4 d-block mb-2"></i>
                              <span>No Image Selected</span>
                            </div>
                          )}
                        </div>

                        {/* Structured Action Buttons */}
                        <div className="mt-3 d-flex justify-content-center gap-2">
                          <Label
                            htmlFor="type-image-input"
                            className="btn btn-light btn-sm border d-flex align-items-center gap-1 cursor-pointer mb-0"
                            title="Upload/Change Image"
                          >
                            <i className="ri-image-add-line"></i>
                            {previewImage ? "Change" : "Select"} Image
                          </Label>

                          {previewImage && validation.values.type === 3 && (
                            <Button
                              type="button"
                              color="primary"
                              size="sm"
                              outline
                              className="d-flex align-items-center gap-1"
                              onClick={() => {
                                setImageToCrop(previewImage);
                                setCropModal(true);
                              }}
                              title="Crop Trial Image"
                            >
                              <i className="ri-crop-2-line"></i> Crop
                            </Button>
                          )}
                        </div>

                        <Input
                          name="formImage"
                          className="form-control d-none"
                          id="type-image-input"
                          type="file"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={handleImageChange}
                        />
                      </div>
                    </div>

                    {/* Required Size Hint - Styled as a badge for better visibility */}
                    {validation.values.type === 3 && (
                      <div className="mt-2">
                        <span className="badge bg-info-subtle text-info p-2 fs-12">
                          <i className="ri-information-line me-1"></i>
                          Required: 1512px (W) × 448px (H)
                        </span>
                      </div>
                    )}

                    {/* Validation Feedback - Only show after submit attempt */}
                    {validation.submitCount > 0 && validation.errors.image ? (
                      <div className="text-danger mt-2" style={{ fontSize: '0.875em', display: 'block' }}>
                        <i className="ri-error-warning-line me-1"></i>
                        {validation.errors.image}
                      </div>
                    ) : null}
                  </div>

                </CardBody>
              </Card>
            </Col>
            <Col lg={4}>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Plan type  <span className="text-danger">*</span></h5>
                </CardHeader>
                <CardBody>
                  <p className="text-muted mb-2">
                    {" "}
                    {/* <Link
                      to="#"
                      className="float-end text-decoration-underline"
                      onClick={() => console.log("Open Modal")}
                    >
                      Add New
                    </Link> */}
                    Select type
                  </p>
                  {/* <select
                    className={`form-control ${validation.errors.type && validation.touched.type ? "is-invalid" : ""}`}
                    id="price-select"
                    name="type"
                    aria-placeholder="Select offer type"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.type}
                  >
                    <option value="">Select Type</option>
                    <option value="1">Regular</option>
                    <option value="2">Combo</option>
                    <option value="3">Trial (Free)</option>
                  </select> */}
                  <select
                    className={`form-control ${validation.errors.type && validation.touched.type ? "is-invalid" : ""}`}
                    id="price-select"
                    name="type"
                    aria-placeholder="Select offer type"
                    onBlur={validation.handleBlur}
                    onChange={(e) => {
                      const value = parseInt(e.target.value);
                      validation.setFieldValue("type", value);
                      validation.setFieldValue("is_trial_plan", value == 3); // Set to true only for Trial (value 3)
                    }}
                    value={validation.values.type}
                  >
                    <option value="">Select Type</option>
                    <option value="1">Regular</option>
                    <option value="2">Combo</option>
                    <option value="3">Trial (Free)</option>
                  </select>

                  {validation.values.is_trial_plan ? (
                    <div className="alert alert-info mt-2">
                      <i className="ri-information-line me-2"></i>
                      This is a free trial plan - users won't be charged
                    </div>
                  ) : (
                    <div className="alert alert-warning mt-2">
                      <i className="ri-money-dollar-circle-line me-2"></i>
                      This is a paid plan - users will be charged
                    </div>
                  )}

                  {validation.touched.type && validation.errors.type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.type}
                    </FormFeedback>
                  ) : null}
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Features  <span className="text-danger">*</span></h5>
                </CardHeader>
                <CardBody>
                  <p className="text-muted mb-2">
                    {/* <Link
                      to="#"
                      className="float-end text-decoration-underline"
                      onClick={() => console.log("Open Modal")}
                    >
                      Add New
                    </Link> */}
                    Select features
                  </p>
                  <Select
                    isMulti
                    name="plan_feature_id"
                    options={availableFeature.map((option) => ({
                      value: option.id,
                      label: option.name,
                    }))}
                    value={availableFeature
                      .filter((option) => selectedFeatures.includes(option.id))
                      .map((option) => ({ value: option.id, label: option.name }))}
                    onChange={(selectedOptions: any) => {
                      const selectedIds = selectedOptions.map((option: any) => option.value);
                      setSelectedFeatures(selectedIds);
                      validation.setFieldValue("plan_feature_id", selectedIds);
                    }}
                    classNamePrefix="react-select"
                  />
                  {validation.touched.plan_feature_id && validation.errors.plan_feature_id ? (
                    <FormFeedback type="invalid">
                      {validation.errors.plan_feature_id}
                    </FormFeedback>
                  ) : null}
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Validity Details <span className="text-danger">*</span></h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    {/* Max Cancel Validity Days */}
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="max_cancel_validity_days" className="form-label">
                          Cancel Limit <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="number"
                          className="form-control"
                          id="max_cancel_validity_days"
                          placeholder="Enter days"
                          name="max_cancel_validity_days"
                          value={validation.values.max_cancel_validity_days || ""}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          invalid={
                            validation.errors.max_cancel_validity_days &&
                            validation.touched.max_cancel_validity_days
                          }
                        />
                        {validation.errors.max_cancel_validity_days &&
                          validation.touched.max_cancel_validity_days ? (
                          <FormFeedback type="invalid">
                            {validation.errors.max_cancel_validity_days}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    {validation.values.type === 3 && (
                      <>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="max_purchase_count" className="form-label">
                              Max Order Count <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="number"
                              className="form-control"
                              id="max_purchase_count"
                              placeholder="Example: 3"
                              name="max_purchase_count"
                              value={validation.values.max_purchase_count}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={validation.touched.max_purchase_count && !!validation.errors.max_purchase_count}
                            />
                            <p className="text-muted small mt-1">(Maximum number of times a user can purchase this trial plan)</p>
                            {validation.errors.max_purchase_count && validation.touched.max_purchase_count ? (
                              <FormFeedback type="invalid">{validation.errors.max_purchase_count}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="max_purchase_product" className="form-label">
                              Max Selectable Products <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="number"
                              className="form-control"
                              id="max_purchase_product"
                              placeholder="Example: 1"
                              name="max_purchase_product"
                              value={validation.values.max_purchase_product}
                              onBlur={validation.handleBlur}
                              onChange={validation.handleChange}
                              invalid={validation.touched.max_purchase_product && !!validation.errors.max_purchase_product}
                            />
                            <p className="text-muted small mt-1">
                              (Limits how many different products a user can pick from the variants below. Example: If 3 products are listed and this is set to 1, the user can only choose any 1 product.)
                            </p>
                            {validation.errors.max_purchase_product && validation.touched.max_purchase_product ? (
                              <FormFeedback type="invalid">{validation.errors.max_purchase_product}</FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </>
                    )}
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="list_order" className="form-label">
                          List Order <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="number"
                          className="form-control"
                          id="list_order"
                          placeholder="Enter order"
                          name="list_order"
                          value={validation.values.list_order}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          invalid={validation.touched.list_order && !!validation.errors.list_order}
                        />
                        {validation.errors.list_order && validation.touched.list_order ? (
                          <FormFeedback type="invalid">{validation.errors.list_order}</FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Subscription Settings <span className="text-danger">*</span></h5>

                  <div className="form-check form-switch">
                    <Input
                      type="switch"
                      id="is-subscription"
                      name="is_subscription"
                      checked={validation.values.is_subscription}
                      onChange={(e) => {
                        validation.setFieldValue("is_subscription", e.target.checked);
                      }}
                    />
                    <Label htmlFor="is-subscription" className="form-check-label">
                      {validation.values.is_subscription ? "Active" : "Inactive"}
                    </Label>
                  </div>

                </CardHeader>
                <div className="alert alert-info mt-2">
                  <i className="ri-information-line me-2"></i>
                  (It is not One time purchase means enable this)
                </div>
              </Card>

              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Referral Details <span className="text-danger">*</span></h5>
                  <div className="form-check form-switch">
                    <Input
                      type="switch"
                      id="referral-status"
                      name="referral-status"
                      checked={validation.values.referral_status}
                      onChange={(e) => {
                        validation.setFieldValue("referral_status", e.target.checked);
                        // Reset values when turning off
                        if (!e.target.checked) {
                          validation.setFieldValue("no_of_delivery_days", 0);
                          validation.setFieldValue("no_of_times_used", 0);
                        }
                      }}
                    />
                    <Label htmlFor="referral-status" className="form-check-label">
                      {validation.values.referral_status ? "Active" : "Inactive"}
                    </Label>
                  </div>
                </CardHeader>
                <CardBody>
                  <Row>
                    {/* Max Referral Days */}
                    <Col md={7}>
                      <div className="mb-3">
                        <Label htmlFor="no_of_delivery_days" className="form-label">
                          Max Referral Days <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="number"
                          className="form-control"
                          id="no_of_delivery_days"
                          placeholder="Enter No of delivery Days to Referral"
                          name="no_of_delivery_days"
                          value={validation.values.no_of_delivery_days || ""}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          invalid={
                            validation.errors.no_of_delivery_days &&
                            validation.touched.no_of_delivery_days
                          }
                          disabled={!validation.values.referral_status}
                        />
                        {validation.errors.no_of_delivery_days &&
                          validation.touched.no_of_delivery_days ? (
                          <FormFeedback type="invalid">
                            {validation.errors.no_of_delivery_days}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>

                    {/* No of times can be used */}
                    <Col md={5}>
                      <div className="mb-3">
                        <Label htmlFor="no_of_times_used" className="form-label">
                          No of times can be used <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="number"
                          className="form-control"
                          id="no_of_times_used"
                          placeholder="Enter No of time this referral can be used"
                          name="no_of_times_used"
                          value={validation.values.no_of_times_used || ""}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          invalid={
                            validation.errors.no_of_times_used &&
                            validation.touched.no_of_times_used
                          }
                          disabled={!validation.values.referral_status}
                        />
                        {validation.touched.no_of_times_used &&
                          validation.errors.no_of_times_used ? (
                          <FormFeedback type="invalid">
                            {validation.errors.no_of_times_used}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <Nav className="nav-tabs-custom card-header-tabs border-bottom-0" role="tablist">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: customActiveTab === "1" })}
                        onClick={() => { toggleCustom("1"); }}
                      >
                        <i className="ri-list-settings-line me-1 align-bottom"></i> Variants
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({ active: customActiveTab === "2" })}
                        onClick={() => { toggleCustom("2"); }}
                      >
                        <i className="ri-image-line me-1 align-bottom"></i> Gallery
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardHeader>
                <CardBody>
                  <TabContent activeTab={customActiveTab}>
                    <TabPane tabId="1">
                      <div className="table-responsive">
                        <Table className="table-nowrap align-middle table-borderless">
                          <thead className="table-light">
                            <tr>
                              <th className="text-center" style={{ width: '5%', color: '#334155' }}>S.No</th>
                              <th className="text-center" style={{ minWidth: '180px', color: '#334155' }}>
                                Product <span className="text-danger">*</span>
                                <div className="text-muted small fw-normal">Select from list & Category</div>
                              </th>
                              <th className="text-center" style={{ minWidth: '150px', color: '#334155' }}>
                                Variant <span className="text-danger">*</span>
                                <div className="text-muted small fw-normal">Select variant</div>
                              </th>
                              <th className="text-center" style={{ minWidth: '120px', color: '#334155' }}>
                                Variant Info
                                <div className="text-muted small fw-normal">Value & Unit</div>
                              </th>
                              <th className="text-center" style={{ minWidth: '140px', color: '#334155' }}>
                                Validity & Free Days <span className="text-danger">*</span>
                                <div className="text-muted small fw-normal">Duration</div>
                              </th>
                              <th className="text-center" style={{ minWidth: '140px', color: '#334155' }}>
                                Amounts <span className="text-danger">*</span>
                                <div className="text-muted small fw-normal">Pricing</div>
                              </th>
                              <th className="text-center" style={{ minWidth: '180px', color: '#334155' }}>
                                Offer Details
                                <div className="text-muted small fw-normal">Choose offer type first</div>
                              </th>
                              <th className="text-center" style={{ minWidth: '140px', color: '#334155' }}>
                                Gross Amt
                                <div className="text-muted small fw-normal">Auto-calculated</div>
                              </th>
                              <th className="text-center" style={{ minWidth: '80px', color: '#334155' }}>
                                Bonus
                                <div className="text-muted small fw-normal">Loyalty</div>
                              </th>
                              <th className="text-center" style={{ minWidth: '100px', color: '#334155' }}>
                                Actions
                                <div className="text-muted small fw-normal">Manage</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <FieldArray validateOnChange={false} name="details">
                              {() => validation.values.details.map((item: any, index: number) => (
                                <React.Fragment key={index}>
                                  <tr className="align-middle" style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f1f5f9' }}>
                                    {/* S.No */}
                                    <td className="text-center fw-bold" style={{ color: '#475569' }}>{index + 1}</td>

                                    {/* Product Dropdown */}
                                    <td>
                                      <Input
                                        type="select"
                                        className="form-select-sm"
                                        name={`details[${index}].product_id`}
                                        value={item.product_id || ""}
                                        onChange={(e) => {
                                          const val = parseInt(e.target.value);
                                          handleProductChange(index, val);
                                        }}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                          validation.errors.details?.[index]?.product_id &&
                                          validation.touched.details?.[index]?.product_id
                                        }
                                        style={{ borderWidth: '2px' }}
                                      >
                                        <option value="" disabled>Select Product</option>
                                        {productList?.map(product => (
                                          <option
                                            key={product.id}
                                            value={product.id}
                                          >
                                            {product.name}
                                          </option>
                                        ))}
                                      </Input>
                                      <Input
                                        type="hidden"
                                        name={`details[${index}].category_id`}
                                        value={item.category_id || ""}
                                      />
                                      {validation.errors.details?.[index]?.product_id &&
                                        validation.touched.details?.[index]?.product_id && (
                                          <div className="text-danger small mt-1">
                                            <i className="ri-alert-fill me-1"></i>
                                            {validation.errors.details[index].product_id}
                                          </div>
                                        )}
                                      {item.product_id > 0 && productList.find(p => p.id === item.product_id)?.variants?.filter((v: any) => {
                                        const isUsed = validation.values.details.some((d: any, i: number) =>
                                          i !== index && Number(d.product_id) === Number(item.product_id) && Number(d.productPriceId) === Number(v.id)
                                        );
                                        return !isUsed;
                                      }).length === 0 && (
                                          <div className="text-danger small mt-1">
                                            <i className="ri-error-warning-fill me-1"></i>
                                            no have remaining variants ({productList.find(p => p.id === item.product_id)?.variants?.map((v: any) => `${v.variant_value}${v.variant?.name || ''}`).join(', ')})
                                          </div>
                                        )}
                                      
                                      <div className="mt-2 d-flex align-items-center gap-1">
                                        <small className="text-muted">Category:</small>
                                        <span className="badge bg-light text-success border">
                                          {productList.find(p => p.id === item.product_id)?.categories?.name || "N/A"}
                                        </span>
                                      </div>
                                    </td>

                                    {/* Variant Selection (ProductPriceId) */}
                                    <td>
                                      <Input
                                        type="select"
                                        className="form-select-sm"
                                        name={`details[${index}].productPriceId`}
                                        value={item.productPriceId || ""}
                                        onChange={(e) => {
                                          const val = parseInt(e.target.value);
                                          handleVariantChange(index, val);
                                        }}
                                        disabled={!item.product_id}
                                        invalid={validation.errors.details?.[index]?.productPriceId && validation.touched.details?.[index]?.productPriceId}
                                        style={{ borderWidth: '2px' }}
                                      >
                                        <option value="" disabled>{item.product_id ? 'Select Variant' : 'Select Product First'}</option>
                                        {productList.find(p => p.id === item.product_id)?.variants?.filter((v: any) => {
                                          const isUsed = validation.values.details.some((d: any, i: number) =>
                                            i !== index && Number(d.product_id) === Number(item.product_id) && Number(d.productPriceId) === Number(v.id)
                                          );
                                          return !isUsed;
                                        }).map((v: any) => (
                                          <option key={v.id} value={v.id}>
                                            {v.variant_value} {v.variant?.name || ''} - ₹{v.actual_amount}
                                          </option>
                                        ))}
                                      </Input>
                                      {validation.errors.details?.[index]?.productPriceId &&
                                        validation.touched.details?.[index]?.productPriceId && (
                                          <div className="text-danger small mt-1">
                                            <i className="ri-error-warning-line me-1"></i>
                                            {validation.errors.details[index].productPriceId}
                                          </div>
                                        )}
                                      <div className="text-muted mt-1" style={{ fontSize: '10px' }}>
                                        <i className="ri-information-fill text-info me-1"></i>
                                        {item.product_id ? 'Choose a variant to update price info' : 'Select product to see variants'}
                                      </div>
                                    </td>

                                    {/* Variant Info (Display only) */}
                                    <td>
                                      <div className="d-flex flex-column gap-2 mt-1">
                                        <div className="badge bg-light text-dark border text-start fw-normal" style={{ fontSize: '10px' }}>
                                          <i className="ri-lock-2-fill text-muted me-1"></i> Read Only: Auto-set
                                        </div>
                                        <Input
                                          type="text"
                                          className="form-control-sm bg-light"
                                          name={`details[${index}].variant_value`}
                                          value={item.variant_value || ""}
                                          readOnly
                                          placeholder="Value"
                                          style={{ borderWidth: '2px' }}
                                        />
                                        <Input
                                          type="select"
                                          className="form-select-sm bg-light"
                                          name={`details[${index}].variant_id`}
                                          value={item.variant_id || ""}
                                          disabled
                                          style={{ borderWidth: '2px' }}
                                        >
                                          <option value="" disabled>Unit</option>
                                          {availableVariants?.map(variant => (
                                            <option key={variant.id} value={variant.id}>{variant.name}</option>
                                          ))}
                                        </Input>
                                      </div>
                                    </td>

                                    {/* Validity & Free Days */}
                                    <td>
                                      <div className="d-flex flex-column gap-2">
                                        <div className="input-group input-group-sm">
                                          <span className="input-group-text bg-light">Days</span>
                                          <Input
                                            type="number"
                                            className="form-control"
                                            name={`details[${index}].validity`}
                                            value={item.validity}
                                            onChange={(e) => handleCombinationChange(index, "validity", e.target.value)}
                                            invalid={validation.errors.details?.[index]?.validity && validation.touched.details?.[index]?.validity}
                                          />

                                        </div>
                                        <div className="input-group input-group-sm">
                                          <span className="input-group-text bg-light">+ Free</span>
                                          <Input
                                            type="number"
                                            className="form-control"
                                            name={`details[${index}].free_validity_days`}
                                            value={item.free_validity_days}
                                            onChange={(e) => handleCombinationChange(index, "free_validity_days", e.target.value)}
                                            invalid={validation.errors.details?.[index]?.free_validity_days && validation.touched.details?.[index]?.free_validity_days}
                                          />
                                        </div>
                                      </div>
                                    </td>

                                    {/* Per Day & Actual Amt */}
                                    <td>
                                      <div className="d-flex flex-column gap-3">
                                        <div className="input-group input-group-sm">
                                          <span className="input-group-text bg-light">Per Day</span>
                                          <Input
                                            type="number"
                                            className="form-control"
                                            name={`details[${index}].per_day_amount`}
                                            value={item.per_day_amount}
                                            onChange={(e) => handleCombinationChange(index, "per_day_amount", e.target.value)}
                                            invalid={validation.errors.details?.[index]?.per_day_amount && validation.touched.details?.[index]?.per_day_amount}
                                          />
                                        </div>
                                        <div className="input-group input-group-sm">
                                          <span className="input-group-text bg-light">Actual</span>
                                          <Input
                                            type="number"
                                            className="form-control"
                                            name={`details[${index}].actual_amount`}
                                            value={item.actual_amount}
                                            onChange={(e) => handleCombinationChange(index, "actual_amount", e.target.value)}
                                            invalid={validation.errors.details?.[index]?.actual_amount && validation.touched.details?.[index]?.actual_amount}
                                          />
                                        </div>
                                      </div>
                                    </td>

                                    {/* Offer Details */}
                                    <td>
                                      <div className="d-flex flex-column gap-2">
                                        <div className="d-flex justify-content-center gap-2">
                                          <Button
                                            color={Number(item.offer_type) === 1 ? "primary" : "light"}
                                            className={`${Number(item.offer_type) === 1 ? 'active' : ''}`}
                                            onClick={() => {
                                              const newType = Number(item.offer_type) === 1 ? 0 : 1;
                                              handleCombinationChange(index, "offer_type", newType);
                                            }}
                                            size="sm"
                                          >
                                            <i className="ri-money-rupee-circle-fill me-1"></i> Amt
                                          </Button>
                                          <Button
                                            color={Number(item.offer_type) === 2 ? "primary" : "light"}
                                            className={`${Number(item.offer_type) === 2 ? 'active' : ''}`}
                                            onClick={() => {
                                              const newType = Number(item.offer_type) === 2 ? 0 : 2;
                                              handleCombinationChange(index, "offer_type", newType);
                                            }}
                                            size="sm"
                                          >
                                            <i className="ri-percent-fill me-1"></i> Percent
                                          </Button>
                                        </div>

                                        <Input
                                          type="number"
                                          className="form-control-sm border-success"
                                          name={`details[${index}].offer_value`}
                                          value={item.offer_value}
                                          onChange={(e) => handleCombinationChange(index, "offer_value", e.target.value)}
                                          placeholder={item.offer_type === 1 ? "Enter discount amount" : "Enter discount %"}
                                          invalid={validation.errors.details?.[index]?.offer_value && validation.touched.details?.[index]?.offer_value}
                                          style={{ borderWidth: '2px' }}
                                        />

                                        {(item.offer_value || item.free_validity_days) && (
                                          <div className="alert alert-success p-1 mb-0 text-center small">
                                            <i className="ri-checkbox-circle-fill me-1"></i>
                                            Total Discount: ₹{
                                              (
                                                item.free_validity_days > 0
                                                  ? parseFloat(item.free_validity_days || "0") * parseFloat(item.per_day_amount || "0")
                                                  : item.offer_type === 1
                                                    ? parseFloat(item.offer_value || "0")
                                                    : item.offer_type === 2
                                                      ? (parseFloat(item.actual_amount || "0") * parseFloat(item.offer_value || "0")) / 100
                                                      : 0
                                              ).toFixed(2)
                                            } {""}{
                                              item.offer_type === 2 ? `(${item.offer_value}%) ` : ''
                                            }
                                            {item.free_validity_days > 0 && (
                                              <span> (Includes {item.free_validity_days} free days)</span>
                                            )}
                                          </div>
                                        )}

                                      </div>
                                    </td>

                                    {/* Gross Amt */}
                                    <td>
                                      <div className=" d-flex justify-content-center gap-0 input-group input-group-sm w-100 ">
                                        <span className="input-group-text bg-light">Total</span>
                                        <Input
                                          type="number"
                                          className="form-control bg-light"
                                          name={`details[${index}].gross_amount`}
                                          value={item.gross_amount}
                                          placeholder="Gross amount"
                                          invalid={validation.errors.details?.[index]?.gross_amount && validation.touched.details?.[index]?.gross_amount}
                                          onChange={(e) => handleCombinationChange(index, "gross_amount", e.target.value)}
                                        />
                                      </div>
                                    </td>

                                    {/* Bonus */}
                                    <td className="text-center">
                                      <div className="d-flex flex-column align-items-center">
                                        <div className="form-check form-switch mb-1">
                                          <Input
                                            type="checkbox"
                                            className="form-check-input"
                                            name={`details[${index}].is_loyalty_bonus`}
                                            checked={item.is_loyalty_bonus || false}
                                            onChange={(e) => validation.setFieldValue(
                                              `details[${index}].is_loyalty_bonus`,
                                              e.target.checked
                                            )}
                                            style={{ cursor: 'pointer', width: '3em', height: '1.5em' }}
                                          />
                                        </div>
                                        <small className={`fw-bold ${item.is_loyalty_bonus ? 'text-success' : 'text-muted'}`}>
                                          {item.is_loyalty_bonus ? (
                                            <span className="badge bg-success bg-opacity-25 text-success">
                                              <i className="ri-gift-fill me-1"></i> Bonus Included
                                            </span>
                                          ) : (
                                            <span className="badge bg-light text-muted border">
                                              <i className="ri-gift-line me-1"></i> No Bonus
                                            </span>
                                          )}
                                        </small>
                                      </div>
                                    </td>
                                    {/* Actions */}
                                    <td className="text-center">
                                      <div className="d-flex justify-content-center gap-0">
                                        {(index === validation.values.details.length - 1) && (
                                          <Button
                                            color="success"
                                            className="btn-icon rounded-circle"
                                            onClick={handleAddRow}
                                            size="sm"
                                            title="Add new row"
                                          >
                                            <i className="ri-add-line"></i>
                                          </Button>
                                        )}
                                        {(validation.values.details.length > 1) && (
                                          <Button
                                            color="danger"
                                            className="btn-icon rounded-circle"
                                            onClick={() => handleRemoveRow(index)}
                                            size="sm"
                                            title="Remove this row"
                                          >
                                            <i className="ri-delete-bin-line"></i>
                                          </Button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>

                                  {/* Error row if any - Only show when there are validation errors */}
                                  {validation.errors.details?.[index] && Object.keys(validation.errors.details[index] as any).length > 0 && (
                                    <tr key={`error-${index}`}>
                                      <td colSpan={10} className="p-0">
                                        <div className="alert alert-danger small px-2 py-1 m-1">
                                          <i className="ri-error-warning-fill me-1"></i>
                                          {Object.entries(validation.errors.details[index] as any).map(([key, error]: any) => (
                                            <span key={key} className="me-2">• {error}</span>
                                          ))}
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))}
                            </FieldArray>
                          </tbody>
                        </Table>
                      </div>
                      <div className="mt-3">
                        <Button
                          color="primary"
                          className="btn-label"
                          onClick={handleAddRow}
                        >
                          <i className="ri-add-line label-icon align-middle fs-16 me-2"></i>
                          Add Row
                        </Button>
                      </div>
                    </TabPane>
                    <TabPane tabId="2">
                      <Row className="mt-4">
                        <Col lg={12}>
                          <div className="mb-4">
                            <h5 className="fs-14 mb-1">Subscription Gallery</h5>
                            <p className="text-muted">Add/Manage Gallery Images for this subscription.</p>
                            <Dropzone onDrop={handleAcceptedFiles}>
                              {({ getRootProps, getInputProps }) => (
                                <div className="dropzone dz-clickable bg-light border-dashed">
                                  <div className="dz-message needsclick text-center p-5" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className="mb-3"><i className="display-4 text-muted ri-upload-cloud-2-fill" /></div>
                                    <h5 className="mb-0">Drop files here or click to upload.</h5>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                            <Row className="mt-4">
                              {galleryImages.map((image, index) => (
                                <Col xl={3} md={4} sm={6} key={image.id} className="mb-3">
                                  <Card className="h-100 border shadow-none mb-0">
                                    <div className="position-relative">
                                      <img src={image.image} alt="Gallery" className="card-img-top img-fluid rounded" style={{ height: '160px', width: '100%', objectFit: 'cover' }} />
                                      <div className="position-absolute top-0 end-0 p-2">
                                        <Button color="danger" size="sm" className="btn-icon rounded-circle" onClick={() => removeGallery(image.id, false)}><i className="ri-delete-bin-fill"></i></Button>
                                      </div>
                                    </div>
                                    <CardBody className="p-2">
                                      <div className="d-flex align-items-center gap-2">
                                        <Label className="mb-0 small text-muted">Order:</Label>
                                        <Input
                                          type="number"
                                          bsSize="sm"
                                          value={image.list_order}
                                          onChange={(e) => handleGalleryOrderChange(image.id, e.target.value, false)}
                                          style={{ width: '60px' }}
                                        />
                                      </div>
                                      <div className="mt-1 text-muted" style={{ fontSize: '10px' }}>
                                        * Orders auto-shift (1 to {galleryImages.length + newGalleryFiles.length})
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              ))}
                              {newGalleryFiles.map((image, index) => (
                                <Col xl={3} md={4} sm={6} key={image.id} className="mb-3">
                                  <Card className="h-100 border shadow-none mb-0">
                                    <div className="position-relative">
                                      <img src={image.preview} alt="New" className="card-img-top img-fluid rounded" style={{ height: '160px', width: '100%', objectFit: 'cover' }} />
                                      <div className="position-absolute top-0 end-0 p-2">
                                        <Button color="danger" size="sm" className="btn-icon rounded-circle" onClick={() => removeGallery(image.id, true)}><i className="ri-close-line"></i></Button>
                                      </div>
                                    </div>
                                    <CardBody className="p-2">
                                      <div className="d-flex align-items-center gap-2">
                                        <Label className="mb-0 small text-muted">Order:</Label>
                                        <Input
                                          type="number"
                                          bsSize="sm"
                                          value={image.list_order}
                                          onChange={(e) => handleGalleryOrderChange(image.id, e.target.value, true)}
                                          style={{ width: '60px' }}
                                        />
                                        <span className="badge bg-warning bg-opacity-10 text-warning ms-auto">New</span>
                                      </div>
                                      <div className="mt-1 text-muted" style={{ fontSize: '10px' }}>
                                        * Orders auto-shift (1 to {galleryImages.length + newGalleryFiles.length})
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>

                </CardBody>
              </Card>
            </Col>
            {validation.errors &&
              typeof validation.errors === 'object' &&
              !Array.isArray(validation.errors) &&
              Object.keys(validation.errors).length > 0 && (
                <div className="row justify-content-center mt-3">
                  <div className="col-md-7">
                    <div className="card text-center bg-light border border-danger">
                      <div className="card-body">
                        {Object.values(validation.errors as Record<string, unknown>).map((err, index) => {
                          if (typeof err === 'string') {
                            return (
                              <p key={index} style={{ color: 'red' }}>
                                {err}
                              </p>
                            );
                          }

                          if (Array.isArray(err)) {
                            return err.map((nestedObj, subIndex) =>
                              nestedObj && typeof nestedObj === 'object'
                                ? Object.entries(nestedObj as Record<string, string>).map(
                                  ([key, value], innerIndex) => (
                                    <p key={`${index}-${subIndex}-${innerIndex}`} style={{ color: 'red' }}>
                                      {value}
                                    </p>
                                  )
                                )
                                : null
                            );
                          }

                          if (typeof err === 'object' && err !== null) {
                            return Object.values(err as Record<string, string>).map((value, subIndex) => (
                              <p key={`${index}-${subIndex}`} style={{ color: 'red' }}>
                                {value}
                              </p>
                            ));
                          }

                          return null;
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              )}


          </Row>
          <div className="text-end mb-3">
            <button type="submit" className="btn btn-success w-sm">
              Submit
            </button>
          </div>
          <CropModal
            isOpen={cropModal}
            toggle={() => setCropModal(false)}
            imageSrc={imageToCrop}
            onCropSave={handleCropSave}
            targetWidth={1512}
            targetHeight={448}
            title="Trial Plan Image Crop"
          />
        </Form>
      </Container>
    </div>
  );
};

export default EditPlanSubscription;
